import { Power3, gsap } from 'gsap';

export const showAnimation = (ref: HTMLDivElement, isShow: boolean) => {
  gsap.to(ref, {
    opacity: isShow ? 1 : 0,
    zIndex: isShow ? 999 : -10,
    duration: 0.5,
    ease: Power3.easeIn
  });
};
